import { useTranslate } from "src/i18n/useTranslate"
import { MBadge } from "src/ui/MBadge/MBadge"

export function BetaAccessBadge() {
  const { tPlaceholder } = useTranslate()

  return <MBadge color="info">{tPlaceholder("Beta access")}</MBadge>
}
